import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from '../../constants/ActionTypes';
import customAxios from '../../util/Api';
import authHeader from '../../../../services/auth/jwt/auth-header';
import { InitialAddEditWoodChipFormData } from '../Data/WoodChipFormDataFields';
import { useToast } from 'context/tostifyContext';

const useTimberSalesPricingListController = () => {
  const [salesPricingData, setSalesPricingData] = useState([]);
  const dispatch = useDispatch();

  const isMounted = useRef(true);
  const { showToast } = useToast();
  useEffect(() => {
    isMounted.current = true;
    getSalesPricingList();
    return () => {
      isMounted.current = false; // Set to false on unmount
    };
  }, []);

  const getSalesPricingList = () => {
    try {
      dispatch({ type: FETCH_START });
      customAxios.get('/Ops/GetTimberPricingList', { headers: authHeader() }).then(response => {
        let correctedData = response.data;

        if (isMounted.current) {
          setSalesPricingData(correctedData);
          dispatch({ type: FETCH_SUCCESS });
        }
        // setSiteAssessmentData(correctedData);
        // dispatch({ type: FETCH_SUCCESS });
      });
    } catch (error) {
      if (isMounted.current) {
        setSalesPricingData([]);
        console.error('error', error);
        dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
      }
    }
  };

  const handleConvertToContract = async data => {
    try {
      dispatch({ type: FETCH_START });

      const response = await customAxios.get(`/CRM/GetCRMSiteDetails?siteAssessmentId=${data.siteAssessmentID}`, {
        headers: authHeader(),
      });

      const crmData = response?.data?.[0];

      if (!crmData) {
        throw new Error('CRM data not found for the given Site Assessment ID.');
      }

      const payload = {
        fellingLicenseNo: crmData.licenseNo,
        siteAssessmentID: data.siteAssessmentID,
        pricingVersion: data.pricingVersion,
      };

      const finalResponse = await customAxios.post('/Ops/ConvertTimberPricingToContract', payload, {
        headers: authHeader(),
      });

      if (finalResponse.status === 200) {
        dispatch({ type: FETCH_SUCCESS });

        if (finalResponse?.data?.newContractUniqueID !== '') {
          showToast(
            `${payload.wH_NumberName} created for Site Assessment ${payload.siteAssessmentID} - Timber Pricing Version ${data.pricingVersion} - Felling License: ${payload.fellingLicenseNo}`,
          );
        } else {
          showToast('Contract already exists for this site assessment!!', 'error');
        }
      }
    } catch (error) {
      console.error('Convert to Contract Error:', error);
      dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
    }
  };

  const createClone = async data => {
    const [base, version] = data.pricingVersion.split('-');
    const newVersion = `${base}-${Number(version) + 1}`;

    const payload = {
      siteAssessmentID: data.siteAssessmentID,
      oldPricingVersion: data.pricingVersion,
      newPricingVersion: newVersion,
      destinationSiteAssessmentID: data.siteAssessmentID,
    };

    const response = await customAxios.post('/Ops/CloneTimberPricing', payload, {
      headers: authHeader(),
    });
    console.log(response);
  };

  const deleteTimberList = async data => {
    const payload = {
      siteAssessmentID: data.siteAssessmentID,
      pricingVersion: data.pricingVersion,
      // subCompartmentName: data.subCompartmentName || '',
    };
    console.log(payload);
    const response = await customAxios.post('/Ops/DeleteTimberPricing', payload, {
      headers: authHeader(),
    });
  };

  return { salesPricingData, handleConvertToContract, createClone, deleteTimberList, getSalesPricingList };
};

export default useTimberSalesPricingListController;
